import hubapiStack from 'hub-http/stacks/hubapi';
import Client from './apiClient/client';
const apiClient = new Client({
  clientStack: hubapiStack
});
export default apiClient;